export default {
  CHANGE: 'CHANGE',
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
};
